<ndt-user-register-view
   [callState]="callState$ | async"
   [dataSource]="dataSource$ | async"
   [includeInactive]="includeInactive$ | async"
   [isLoading]="isLoading$ | async"
   [hasNextPage]="hasNextPage$ | async"
   [pagingCallState]="pagingCallState$ | async"
   [totalCount]="totalCount$ | async"
   [name]="entityName"
   [columns]="columns$ | async"
   [route]="route"
   [userPrivileges]="userPrivileges$ | async"
   [showCreate]="showCreate"
   [showAllUsersControl]="showAllUsersControl"
   (create)="onCreate()"
   (quickFilterChange)="onQuickFilterChange($event)"
   (orderingOptionsChange)="onOrderingOptionsChange($event)"
   [orderingOptions]="orderingOptions$ | async"
   (loadMore)="onLoadMore()"
>
</ndt-user-register-view>
